import { getCurrentUser } from 'redux/query';

export const hasZppCourseAttendances = (state) => {
  const user = getCurrentUser(state);
  return (
    !!(user?.zppCourseAttendances || []).length &&
    user?.zppCourseAttendances.some((attendance) => ['sda', 'resilienz', 'resilience'].includes(attendance?.courseType))
  );
};
